<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container">
        <h2 class="hyper-link medicationTitle mb-4">
          <!-- Treatments -->
          Medication
          <a-tooltip placement="topLeft" overlayClassName="ant-dovemed-tooltip">
            <template slot="title">
              <span> Adding treatments you take and its effectiveness, will help other members taking similar treatments connect with you. </span>
            </template>
            <!-- :style="{
                color: `#2A71D4 !important`,
                'font-size': '14px',
                position: 'absolute'
              }" -->
            <i class="fa fa-question-circle question-icon" aria-hidden="true" :style="`color:#2A71D4 !important`"></i>
          </a-tooltip>
        </h2>
        <p class="bold-text treatmentDescription">
          {{ authUser.user.role === "patient" ? "What treatments and therapies have you used or are using?" : "What treatments and therapies have the patient used or is using?" }}
        </p>
        <p class="example mb-0">(For example: Medicine, Surgery, Jogging, etc)</p>
        <div class="add-treatment">
          <div @click="openTreatmentModal" class="add-symptoms add-treatment-btn">
            <!-- <div class="left-line"></div>
            <hr class="top-line" />
            <hr class="bottom-line" /> -->
            <div class="plus-icon">
              <!-- <img src="../../../assets/images/plus-icon.png" /> -->
              <font-awesome-icon size="1x" class="mr-2" :style="{ color: getPrimaryColor() }" :icon="['fas', 'plus']" />
            </div>
            <span class="addtreatment-text" :style="{ color: getPrimaryColor() }"> Add Medication </span>
          </div>
          <div class="treatments-container row" v-if="treatmentsArr.length">
            <div class="treatments-card d-flex flex-column" v-for="(treatment, index) in treatmentsArr" :key="treatment.treatment_name">
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-left">
                  <p class="text-capitalize m-0 medicineName">
                    {{ treatment.treatment[0].display_name }}
                  </p>
                  <!-- <p
                    class="  text-capitalize m-0"
                    :style="{ 'font-size': '16px', 'font-weight': 'bold' }"
                  >
                    {{ treatment.treatment_type }}
                    <span
                      v-if="
                        treatment.treatment_type === 'Procedure' &&
                          treatment.treatment[0].sub_type.length
                      "
                      >(<span
                        class="procedure-types"
                        v-for="(type, index) in treatment.treatment[0].sub_type"
                        :key="index"
                        >{{ type }}</span
                      >)</span
                    >
                  </p> -->
                </div>

                <div class="position-relative">
                  <div class="delete-btn" @click="() => (showDelete = index)">
                    <!-- @click="() => $refs.removeTreatmentModal.show(treatment)" -->
                    <span class="icon cp">
                      <font-awesome-icon
                        size="2x"
                        :style="{
                          color: '#FF9999',
                          transform: 'scale(0.5)',
                          'margin-left': '5px',
                        }"
                        :icon="['fas', 'trash']"
                      />
                    </span>
                    <span class="delete-text">Delete</span>
                  </div>
                  <div class="position-absolute delete-popup shadow-card" v-if="showDelete === index">
                    <p class="font-black mb-2">Are you sure you want to delete this？</p>
                    <div class="d-flex justify-content-end">
                      <span class="cancel-box cp rounded" @click="() => (showDelete = null)"> Cancel </span>
                      <span class="ok-box cp rounded" @click.stop="() => removeTreatment(treatment)" :style="{ 'background-color': getPrimaryColor() }"> Ok </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="effectivenessWrapper">
                <span>Effectiveness:</span>
                <div class="d-flex effectiveness-value">
                  <span
                    :style="{
                      color: getEffectivenessColor(treatment.effectiveness),
                      background: `${getEffectivenessColor(treatment.effectiveness)}25`,
                      padding: '4px 8px',
                      height: 'fit-content',
                      display: 'flex',
                      'border-radius': '5px',
                      'font-weight': '700',
                      'font-size': '12px',
                      'margin-right': '5px',
                    }"
                  >
                    {{ getEffectiveness(treatment.effectiveness) }}
                  </span>
                </div>
              </div>
              <div
                v-if="treatment.side_effect.length"
                :style="{
                  display: 'flex',
                  'flex-wrap': 'wrap',
                  'align-items': 'center',
                  'font-weight': '700',
                  'margin-top': '16px',
                }"
              >
                <div class="d-flex align-items-center sideEffectsText">Side Effects :</div>
                <div class="d-flex flex-wrap">
                  <div v-for="(symptom, index) in treatment.side_effect" :key="index">
                    <div class="eachSideEffectContainer" v-if="symptom.display_name">
                      <div :style="{ width: '100%', 'text-align': 'initial', color: '#333333' }">
                        {{ symptom.display_name }}
                      </div>
                      <div class="sideEffectLabel" :style="{ color: getSideEffectColor(symptom.effectiveness), background: `${getSideEffectColor(symptom.effectiveness)}25`, margin: '0 0px 0 8px;' }">
                        {{ getSideEffect(symptom.effectiveness) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="durationWrapper" v-for="duration in treatment.treatment_duration" :key="duration">
                <div class="durationGroup">
                  <span class="durationLabel">From:</span>
                  <span class="durationValue">
                    {{ getDurationDate(duration[0]) }}
                  </span>
                </div>
                <div class="durationGroup durationGroupTo">
                  <span class="durationLabel">To:</span>
                  <span class="durationValue">
                    {{ !duration[1] ? "Currently Using" : getDurationDate(duration[1]) }}
                  </span>
                </div>
              </div> -->
              <div class="durationWrapper">
                <div class="durationGroup">
                  <span class="durationLabel">From:</span>
                  <span class="durationValue">
                    {{ getDurationDate(treatment.treatment_duration[0][0]) }}
                  </span>
                </div>
                <div class="durationGroup durationGroupTo">
                  <span class="durationLabel">To:</span>
                  <span class="durationValue">
                    {{ !treatment.treatment_duration[0][1] ? "Currently Using" : getDurationDate(treatment.treatment_duration[0][1]) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="buttons-group text-right col-md-12 col-sm-12 mt-5 p-0">
            <!-- <router-link
              :to="{
                path: 'other_symptoms',
                query: { role: authUser.user.role }
              }"
              class="float-left"
            > -->
            <router-link
              :to="{ name: 'OtherSymptonsSignup', query: { role: authUser.user.role } }"
              class="float-left"
              :style="{ 'background-color': '#FFF !important', display: treatmentsArr.length !== 0 ? 'none' : 'inline-block', 'text-decoration': 'none' }"
            >
              <div class="hyper-link skipLater cp" :style="{ color: getPrimaryColor() }">Skip for later</div>
            </router-link>
            <div class="d-flex last-2-btns">
              <!-- <router-link
                :to="{ path: 'symptoms', query: { role: authUser.user.role } }"
              > -->
              <router-link
                :to="{
                  name: 'UserSymptoms',
                  query: { role: authUser.user.role },
                }"
              >
                <button
                  class="dovemed-button hyper-link treatment-button"
                  :style="{
                    border: '1px solid #E2E8F0',
                    color: '#47556E',
                    background: '#E2E8F0',
                  }"
                >
                  <!-- @click="
                  () =>
                    this.$router.push({
                      name: 'UserSymptoms',
                      query: { role: this.formResponses.role }
                    })
                " -->
                  <!-- @click="$router.go(-1)" -->
                  <span>Back</span>
                </button>
              </router-link>
              <router-link
                :to="{
                  name: 'OtherSymptonsSignup',
                  query: { role: authUser.user.role },
                }"
                :style="{ 'background-color': '#FFF !important' }"
              >
                <!-- <router-link
                :to="{
                  path: 'other_symptoms',
                  query: { role: authUser.user.role }
                }"
              > -->
                <a-button
                  :disabled="treatmentsArr.length === 0"
                  class="dovemed-button font-white next-button primary-button treatment-button"
                  :style="{
                    background: getPrimaryColor(),
                    opacity: treatmentsArr.length === 0 ? '0.3' : '1',
                    height: '100% !important',
                  }"
                >
                  <span :style="{ color: '#fff !important' }">Next</span>
                </a-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <AddTreatmentModal ref="addTreatmentModal" v-on:refresh="init" /> -->
    <AddMedicationModal ref="addMedicationModal" v-on:refresh="init" />
    <!-- <RemoveTreatment ref="removeTreatmentModal" v-on:refresh="init" /> -->
  </div>
</template>

<script>
// import AddTreatmentModal from "../../Modals/AddTreatment";
import AddMedicationModal from "../../Modals/AddMedication.vue"
// import RemoveTreatment from "../../Modals/DeleteTreatment";
import { RepositoryFactory } from "../../../repositories/RepositoryFactory"

const UserRepository = RepositoryFactory.get("user")

export default {
  name: "UserTreatments",
  components: {
    // AddTreatmentModal,
    AddMedicationModal,
    // RemoveTreatment
  },
  data() {
    return {
      treatmentsArr: [],
      showDelete: null,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const user = JSON.parse(localStorage.getItem("user"))
      const currentCircle = JSON.parse(localStorage.getItem("currentCircle"))
      // UserRepository.getTreatments(user, currentCircle.id)
      // .then(res => {
      //   if (res.data) {
      //     this.treatmentsArr = res.data.data.circle_treatments.map(ele => {
      //       return {
      //         display_name: ele.display_name,
      //         effectiveness: ele.effectiveness
      //       };
      //     });
      //   } else {
      //     this.treatmentsArr = [];
      //   }

      //   this.load = true;
      // })
      // .catch(err => null);

      const url = `${process.env.BASE_API_URL}/treatment/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}&role=${this.authUser.user.role}&show_used=true`
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      // await this.$store.dispatch('Signup/getTreatment', { url: urlWithParams, payload, headers })
      this.$http
        .get(url, { headers })
        .then(result => {
          if (result.status === 200 || result.status === 201) {
            this.treatmentsArr = result.data.data.map(ele => {
              ele.treatment[0].display_name = ele.treatment[0].display_name.toLowerCase()
              return ele
            })
            // console.log("treatmentsArr:", this.treatmentsArr)
          } else {
            this.treatmentsArr = []
          }
        })
        .catch(err => null)
    },
    openTreatmentModal() {
      // this.$refs.addTreatmentModal.show("", this.init);
      this.$refs.addMedicationModal.show("", this.init)
    },

    /**
     * Remove treatment form Circle
     */
    async removeTreatment(treatment) {
      this.showDelete = null
      const user = JSON.parse(localStorage.getItem("user"))
      const url = `${process.env.BASE_API_URL}/treatment/?ids=${treatment.id}`
      const payload = { id: treatment.id }
      const headers = { Authorization: `Bearer ${user.user.token}` }
      await this.$store.dispatch("Signup/removeTreatment", {
        url,
        payload,
        headers,
      })
      // window.location.reload();
      this.init()
    },
    nth(day) {
      if (day > 3 && day < 21) return "th"
      switch (day % 10) {
        case 1:
          return "st"
        case 2:
          return "nd"
        case 3:
          return "rd"
        default:
          return "th"
      }
    },
    getMonthName(monthNumber) {
      // console.log("getMonthName() -> monthNumber:", monthNumber)
      switch (monthNumber) {
        case 0:
          return "January"
        case 1:
          return "February"
        case 2:
          return "March"
        case 3:
          return "April"
        case 4:
          return "May"
        case 5:
          return "June"
        case 6:
          return "July"
        case 7:
          return "August"
        case 8:
          return "September"
        case 9:
          return "October"
        case 10:
          return "November"
        case 11:
          return "December"
      }
    },
    getDurationDate(dateString) {
      if (this.isDateToday(dateString ? new Date(dateString) : new Date())) {
        return "Today"
      } else {
        return new Date(dateString).toDateString().substring(4)
      }
    },
    getEffectiveness(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "Not Effective"
        case "50":
          return "Somewhat Effective"
        case "100":
          return "Very Effective"
        default:
          break
      }
    },

    getEffectivenessColor(effectiveness) {
      switch (effectiveness) {
        case "100":
          return "#14DE0D"
        case "50":
          return "#F6B156"
        case "0":
          return "#FF4400"
        default:
          break
      }
    },
    getSideEffect(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "Mild"
        case "50":
          return "Moderate"
        case "100":
          return "Severe"
        default:
          break
      }
    },
    getSideEffectColor(effectiveness) {
      switch (effectiveness) {
        case "0":
          return "#14DE0D"
        case "50":
          return "#F6B156"
        case "100":
          return "#FF4400"
        default:
          break
      }
    },
  },
  mounted() {
    // this.init();
    window.scrollTo(0, 0)
  },
}
</script>

<style lang="scss" scoped>
.icon {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  display: inline-block;
  color: #fff !important;
  padding: 0;
  // margin-bottom: 5px;
  transform: translateY(-4px);
}

.white-font {
  color: #fff;
}

.medication-border {
  border: 1px solid rgb(254, 234, 118);
}

.activity-border {
  border: 1px solid rgb(88, 225, 117) !important;
}

.procedure-border {
  border: 1px solid rgb(224, 91, 169);
}

.treatments-card {
  display: flex;
  justify-content: space-between;
  // background: rgba(37, 103, 237, 0.05);
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  // margin-top: 24px;
  padding: 20px;
  width: 100%;
  .medicineName {
    font-weight: 700;
    font-size: 20px;
    color: #0f1734;
  }
  .delete-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .delete-text {
    color: #ea3100;
    font-weight: 700;
    font-size: 14px;
    margin: 0 6px;
  }
  .effectivenessWrapper {
    font-weight: 700;
    font-size: 12px;
    color: #0f1734;
    display: flex;
    align-items: center;
    margin-top: 16px;
    // margin-bottom: 16px;
    .effectiveness-value {
      margin: 0 16px;
    }
  }
  .sideEffectsText {
    font-weight: 700;
    font-size: 12px;
    color: #0f1734;
    margin-right: 10px;
  }
  .sideEffectLabel {
    padding: 4px 8px;
    font-weight: 700;
    font-size: 12px;
    margin: 0 8px;
    line-height: 12px;
  }
  .durationWrapper,
  .durationGroup {
    display: flex;
  }
  .durationWrapper {
    .durationGroupTo {
      margin: 0 16px;
    }
    .durationGroup {
      .durationLabel,
      .durationValue {
        font-weight: 400;
        font-size: 12px;
        color: #0f1734;
      }
      .durationValue {
        margin: 0 4px;
      }
    }
  }
}
.treatments-container {
  margin-right: 0px;
  margin-left: 0px;
  width: 68%;
  gap: 16px;
  margin-top: 24px;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
.border-0 {
  border: 2px solid #ff0000 !important;
}
.border-50 {
  border: 2px solid #ffa500 !important;
}
.border-100 {
  border: 2px solid #008000 !important;
}
p.small {
  font-size: 14px;
}
h5.small {
  font-size: 18px;
  font-weight: bold;
}
.add-treatment-btn {
  margin-top: 4.5em;
  @media screen and (max-width: 900px) {
    width: 100%;
  }
}
// .add-symptoms {
//   width: 540px;
//   font-size: 14px;
//   font-weight: 700;
//   padding-top: 24px;
//   padding-bottom: 24px;
//   // margin-bottom: 10px;
//   margin: 4.5em 0 3em 0;
//   background: #F8FAFD;
//   border: 1px dashed #c4cdd6;
//   border-style: dashed;
//   border-radius: 6px;
//   cursor: pointer;
//   color: #2A71D4;
//   @media screen and (max-width: 900px) {
//     height: 56px;
//     font-size: 14px;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//   }
// }
.treatment-button {
  font-weight: 700;
  font-size: 14px;
  border-radius: 6px;
  background: #e2e8f0;
  @media screen and (max-width: 900px) {
    padding: 10px 50px;
  }

  @media screen and (max-width: 600px) {
    padding: 10px 25px;
  }
}
.dovemed-wrapper {
  max-width: 800px;
}
.dovemed-button {
  padding: 12px 24px;

  @media screen and (max-width: 900px) {
    padding: 12px 25px;
  }
}
.signup-container {
  width: 100%;
  @media screen and (max-width: 900px) {
    width: auto;
  }
  .add-treatment {
    display: flex;
    flex-direction: column;
    align-items: center;
    .add-symptoms {
      display: flex;
      align-items: center;
      justify-content: center;
      // .plus-icon{
      //   font-family: Lato;
      //   font-weight: 700;
      //   color: #2a71d4;
      //   font-size: 30px;
      // }
      .addtreatment-text {
        font-size: 14px;
        margin: 0 8px;
        font-family: Lato;
        font-weight: 700;
        color: #2a71d4;
      }
    }
  }
  .medicationTitle {
    color: #1e2945 !important;
    font-weight: 700;
    font-size: 36px;
    font-family: "Lato";
    .question-icon {
      font-size: 20px;
      margin: 0 6px;
      position: absolute;
      cursor: pointer;
    }
  }
  .treatmentDescription {
    margin: 0px 0 8px 0;
    font-size: 16px;
    color: #647490;
    font-weight: 700;
  }
  .example {
    color: #647490;
    font-weight: 400;
    font-size: 16px;
  }
  .buttons-group {
    width: 70%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    @media screen and (max-width: 900px) {
      width: 100%;
    }
  }
  .skipLater {
    font-weight: 700;
    font-size: 14px;
  }
  @media screen and (max-width: 900px) {
    width: 90%;
  }
}
.next-button {
  margin-left: 12px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  span {
    color: #fff !important;
  }
  // @media screen and (max-width: 900px) {
  //   margin-left: 5px;
  // }
}
.procedure-types {
  &::after {
    content: ",";
  }
  &:last-child::after {
    content: "";
  }
}
.display-symptom {
  justify-content: space-between;
  padding: 16px 24px;
  background: rgba(37, 103, 237, 0.05);
  border-radius: 5px;
  font-size: 14px;
}
.eachSideEffectContainer {
  color: #0f1734;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  padding: 5px 10px;
  // padding: 12px 16px;
  margin: 5px 5px 5px 0;
  min-width: 100px;
  border-radius: 8px;
  font-size: 12px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
}
.durationWrapper {
  margin-top: 32px;
}
.delete-popup {
  top: -100px;
  width: 310px;
  z-index: 1;
  @media screen and (max-width: 900px) {
    right: 0px;
    // left: -200px;
  }
}
.ok-box {
  margin: auto 1em;
  // background: #2A71D4 !important;
  color: white !important;
  padding: 1px 10px;
}
.cancel-box {
  margin: auto 1em;
  background: rgb(226, 232, 240) !important;
  color: black !important;
  padding: 1px 10px;
}
.last-2-btns {
  justify-content: end;
  flex: 1;
}
@media screen and (max-width: 600px) {
  .float-left {
    width: 100%;
    text-align: left;
  }
  .last-2-btns {
    gap: 10px;
    width: 100%;
    a {
      width: 50% !important;
      button {
        width: 100% !important;
      }
    }
  }
  .next-button {
    margin-left: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/Treatments.vue